'use strict';

(function () {
	window.App = window.App || {};

	var MODAL_ID = 'app-bulk-delete-confirm-modal';
	var activeRequest = null;

	function pluralize(count, singular, plural) {
		return count === 1 ? singular : (plural || singular + 's');
	}

	function escapeHtml(value) {
		return String(value == null ? '' : value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	window.App.escapeHtml = escapeHtml;

	window.App.confirmWarningBody = function (message) {
		return (
			'<div class="d-flex align-items-center gap-4">' +
				'<span class="symbol symbol-35px flex-shrink-0">' +
					'<span class="symbol-label bg-light-warning rounded-circle">' +
						'<i class="bi bi-exclamation-lg text-warning fs-3" aria-hidden="true"></i>' +
					'</span>' +
				'</span>' +
				'<span>' + escapeHtml(message) + '</span>' +
			'</div>'
		);
	};

	function otherShownModals(excludeEl) {
		return Array.prototype.filter.call(document.querySelectorAll('.modal.show'), function (el) {
			return el !== excludeEl;
		});
	}

	function raiseAboveOpenModals(modalEl) {
		var others = otherShownModals(modalEl);
		if (!others.length) {
			return;
		}

		var maxZ = 1055;
		others.forEach(function (el) {
			var z = parseInt(window.getComputedStyle(el).zIndex, 10);
			if (!isNaN(z) && z > maxZ) {
				maxZ = z;
			}
		});

		modalEl.style.zIndex = String(maxZ + 10);

		var backdrops = document.querySelectorAll('.modal-backdrop');
		var backdrop = backdrops[backdrops.length - 1];
		if (backdrop) {
			backdrop.style.zIndex = String(maxZ + 5);
			modalEl._appConfirmRaisedBackdrop = backdrop;
		}
	}

	function clearRaisedStacking(modalEl) {
		modalEl.style.zIndex = '';
		if (modalEl._appConfirmRaisedBackdrop) {
			modalEl._appConfirmRaisedBackdrop.style.zIndex = '';
			modalEl._appConfirmRaisedBackdrop = null;
		}
	}

	function restoreNestedModalState(modalEl) {
		var others = otherShownModals(modalEl);
		if (!others.length) {
			return;
		}

		document.body.classList.add('modal-open');
		others.forEach(function (el) {
			el.setAttribute('aria-hidden', 'false');
			if ('inert' in el) {
				el.inert = false;
			}
			el.removeAttribute('inert');
		});
	}

	function buildCopy(entity, count, name, overrides) {
		overrides = overrides || {};
		var n = Math.max(0, parseInt(count, 10) || 0);
		var boldCount;
		var body;
		var title;
		var subtitle = '(' + n + ' selected)';
		var safeName = escapeHtml(name || 'selected');

		switch (entity) {
			case 'contacts':
				title = 'Delete ' + pluralize(n, 'Contact', 'Contacts');
				boldCount = n + ' ' + pluralize(n, 'contact', 'contacts');
				body = 'You are about to delete <strong>' + boldCount + '</strong>, along with their related history, connection to deals/properties, notes, opportunities and files on those contact\'s account.';
				break;
			case 'companies':
				title = 'Delete ' + pluralize(n, 'Company', 'Companies');
				boldCount = n + ' ' + pluralize(n, 'company', 'companies');
				body = 'You are about to delete <strong>' + boldCount + '</strong>, along with their related history, connection to deals/properties, notes, opportunities and files on those company\'s account.';
				break;
			case 'deals':
				title = 'Delete ' + pluralize(n, 'Deal', 'Deals');
				boldCount = n + ' ' + pluralize(n, 'deal', 'deals');
				body = 'You are about to delete <strong>' + boldCount + '</strong>, along with their related history, connection to deals/properties, notes, opportunities and files that are directly tied to those deals.';
				break;
			case 'portfolios':
				title = 'Delete ' + pluralize(n, 'Portfolio', 'Portfolios');
				boldCount = n + ' ' + pluralize(n, 'portfolio', 'portfolios');
				body = 'You are about to delete <strong>' + boldCount + '</strong>, along with their related history, connection to deals/properties, notes, opportunities and files that are directly tied to those portfolios.';
				break;
			case 'invoices':
				title = 'Delete ' + pluralize(n, 'Invoice', 'Invoices');
				boldCount = n + ' ' + pluralize(n, 'invoice', 'invoices');
				body = 'You are about to delete <strong>' + boldCount + '</strong>. This action cannot be undone.';
				break;
			case 'files':
				title = 'Delete ' + pluralize(n, 'File', 'Files');
				boldCount = n + ' ' + pluralize(n, 'file', 'files');
				body = 'You are about to delete <strong>' + boldCount + '</strong>. This action cannot be undone.';
				break;
			case 'contactGroups':
				title = 'Delete Contact Group';
				body = 'You are about to delete <strong>1 contact group</strong>. Contacts in the group are not deleted.';
				subtitle = '(1 selected)';
				break;
			case 'permissions':
				title = 'Delete Permission';
				body = 'You are about to delete the <strong>' + safeName + '</strong> permission.';
				subtitle = '(1 selected)';
				break;
			case 'named':
				title = overrides.title || 'Delete';
				body = overrides.body || ('You are about to delete <strong>' + safeName + '</strong>.');
				subtitle = '(1 selected)';
				break;
			default:
				title = 'Delete';
				body = 'You are about to delete <strong>' + n + '</strong> item(s).';
				break;
		}

		if (overrides.title) {
			title = overrides.title;
		}
		if (overrides.body) {
			body = overrides.body;
		}
		if (overrides.subtitle) {
			subtitle = overrides.subtitle;
		}

		return { title: title, subtitle: subtitle, body: body };
	}

	function getModalEl() {
		return document.getElementById(MODAL_ID);
	}

	function applyModalContent(options) {
		options = options || {};
		var titleEl = document.getElementById('app-bulk-delete-confirm-title');
		var subtitleEl = document.getElementById('app-bulk-delete-confirm-subtitle');
		var bodyEl = document.getElementById('app-bulk-delete-confirm-body');
		var submitBtn = document.getElementById('app-bulk-delete-confirm-submit');
		var cancelBtn = document.getElementById('app-bulk-delete-confirm-cancel');
		var isAlert = !!options.alert;

		if (titleEl) {
			titleEl.textContent = options.title || '';
		}

		if (subtitleEl) {
			var subtitle = options.subtitle || '';
			subtitleEl.textContent = subtitle;
			subtitleEl.classList.toggle('d-none', subtitle === '');
		}

		if (bodyEl) {
			if (options.html) {
				bodyEl.innerHTML = options.body || '';
			} else {
				bodyEl.textContent = options.body || '';
			}
		}

		if (submitBtn) {
			submitBtn.classList.toggle('d-none', isAlert);
			submitBtn.disabled = !!options.confirmDisabled;
			if (!isAlert) {
				submitBtn.textContent = options.confirmText || 'Confirm';
				submitBtn.className = 'btn fw-bold ' + (options.confirmClass || 'btn-red');
			}
		}

		if (cancelBtn) {
			cancelBtn.textContent = options.cancelText || (isAlert ? 'Ok' : 'Cancel');
		}
	}

	function settle(request, asConfirm) {
		if (!request || request.settled) {
			return;
		}

		request.settled = true;
		if (activeRequest === request) {
			activeRequest = null;
		}

		var fn = asConfirm ? request.onConfirm : request.onCancel;
		if (typeof fn === 'function') {
			fn();
		}
	}

	function bindOnce() {
		var modalEl = getModalEl();
		if (!modalEl || modalEl.dataset.bound === '1') {
			return;
		}
		modalEl.dataset.bound = '1';

		var submitBtn = document.getElementById('app-bulk-delete-confirm-submit');
		if (submitBtn) {
			submitBtn.addEventListener('click', function () {
				var request = modalEl._appConfirmRequest;
				settle(request, true);
				var instance = window.bootstrap?.Modal?.getInstance?.(modalEl);
				instance?.hide?.();
			});
		}

		modalEl.addEventListener('hide.bs.modal', function () {
			if (!modalEl._appConfirmClosingRequest) {
				modalEl._appConfirmClosingRequest = modalEl._appConfirmRequest;
			}
		});

		modalEl.addEventListener('shown.bs.modal', function () {
			raiseAboveOpenModals(modalEl);
		});

		modalEl.addEventListener('hidden.bs.modal', function () {
			var request = modalEl._appConfirmClosingRequest;
			modalEl._appConfirmClosingRequest = null;
			clearRaisedStacking(modalEl);
			restoreNestedModalState(modalEl);
			if (request && !request.settled) {
				settle(request, false);
			}
		});
	}

	function showModal(onConfirm, onCancel) {
		var modalEl = getModalEl();
		if (!modalEl) {
			notifyUnavailable('App.confirmModal: modal #' + MODAL_ID + ' not found');
			return false;
		}

		var ModalCtor = window.bootstrap && window.bootstrap.Modal;
		if (!ModalCtor) {
			notifyUnavailable('App.confirmModal: bootstrap.Modal unavailable');
			return false;
		}

		bindOnce();

		if (activeRequest && !activeRequest.settled) {
			settle(activeRequest, false);
		}

		var request = {
			onConfirm: typeof onConfirm === 'function' ? onConfirm : null,
			onCancel: typeof onCancel === 'function' ? onCancel : null,
			settled: false,
		};

		activeRequest = request;
		modalEl._appConfirmRequest = request;

		if (modalEl.classList.contains('show')) {
			modalEl._appConfirmClosingRequest = null;
			return true;
		}

		ModalCtor.getOrCreateInstance(modalEl).show();
		raiseAboveOpenModals(modalEl);

		return true;
	}

	/**
	 * @param {{ title: string, body: string, subtitle?: string, html?: boolean, alert?: boolean, confirmText?: string, cancelText?: string, confirmClass?: string, confirmDisabled?: boolean, onConfirm?: Function, onCancel?: Function }} options
	 * @returns {boolean|undefined}
	 */
	window.App.confirmModal = function (options) {
		options = options || {};

		if (!options.alert && typeof options.onConfirm !== 'function') {
			return false;
		}

		applyModalContent(options);

		if (options.alert) {
			return showModal(null, null);
		}

		return showModal(options.onConfirm, options.onCancel);
	};

	function notifyUnavailable(debugMessage) {
		console.error(debugMessage);
		if (typeof window.toastError === 'function') {
			window.toastError('Confirmation is unavailable. Please refresh the page.');
		}
	}

	/**
	 * @param {{ entity: string, count: number, name?: string, title?: string, body?: string, subtitle?: string, onConfirm: Function }} options
	 */
	window.App.confirmBulkDelete = function (options) {
		options = options || {};
		var count = parseInt(options.count, 10) || 0;
		if (count < 1) {
			return;
		}
		if (typeof options.onConfirm !== 'function') {
			return;
		}

		var copy = buildCopy(options.entity, count, options.name, {
			title: options.title,
			body: options.body,
			subtitle: options.subtitle,
		});

		applyModalContent({
			title: copy.title,
			subtitle: copy.subtitle,
			body: copy.body,
			html: true,
			confirmText: 'Confirm Delete',
			confirmClass: 'btn-red',
			cancelText: 'Cancel',
		});

		showModal(options.onConfirm, null);
	};
})();
